import React from "react";
import { func, oneOfType, number, string } from "prop-types";
import { Form, InputNumber, Button, Typography } from "antd";
import MoneyInput from "../../shared/MoneyInput";

// Calculator card visually separated from the persisted service-fee fields.
const calculatorStyle = {
  flex: "1 1 300px",
  padding: "12px 16px",
  background: "#fafafa",
  border: "1px solid #f0f0f0",
  borderRadius: 8,
};
const inputsRow = {
  display: "flex",
  gap: "24px",
  width: "100%",
  flexWrap: "wrap",
  marginTop: 8,
};
const feeRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  padding: "2px 0",
  marginTop: 12,
};

// Derives a suggested service fee from a percentage + fixed fee, kept separate
// from the persisted Product Service Fees so staff can copy or apply it.
export default function ServiceFeeCalculator({
  calculatedServiceFees,
  onApply,
  onCopy,
}) {
  return (
    <div style={calculatorStyle}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Fee Calculator - Use these fields to calculate the total service fee,
        then copy or apply it to the Product Service Fees box.
      </Typography.Text>
      <div style={inputsRow}>
        <Form.Item
          label="Percentage of Product"
          name="percentageOfProduct"
          style={{ marginBottom: 0 }}
        >
          <InputNumber min={0} max={100} addonAfter="%" />
        </Form.Item>
        <Form.Item
          label="Fixed Fee"
          name="fixedFee"
          style={{ marginBottom: 0 }}
        >
          <MoneyInput />
        </Form.Item>
      </div>
      <div style={feeRow}>
        <Typography.Text type="secondary">Calculated Fee</Typography.Text>
        <Typography.Text strong>
          ${Number(calculatedServiceFees).toFixed(2)}
        </Typography.Text>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <Button onClick={onCopy}>Copy to Clipboard</Button>
        <Button type="primary" onClick={onApply}>
          Apply to Product Service Fee
        </Button>
      </div>
    </div>
  );
}

ServiceFeeCalculator.propTypes = {
  calculatedServiceFees: oneOfType([number, string]),
  onApply: func,
  onCopy: func,
};
